module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-full h-full px-4 py-4 bg-white rounded-b-lg"
  }, [_c('div', {
    staticClass: "space-y-6 font-manrope"
  }, [_c('section', {
    staticClass: "rounded-xl border border-gray-200",
    attrs: {
      "aria-labelledby": "instructions-title"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "relative"
  }, [_c('div', {
    staticClass: "px-4 py-3 sm:px-5 overflow-x-auto"
  }, [_c('div', {
    staticClass: "instructions-container prose prose-sm sm:prose-base max-w-none break-words",
    domProps: {
      "innerHTML": _vm._s(_vm.getCurrentDiscussion.instructions)
    }
  })])])]), _vm._v(" "), _c('section', {
    staticClass: "rounded-xl border border-gray-200",
    attrs: {
      "aria-labelledby": "resources-title"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "px-4 py-3 sm:px-5"
  }, [_c('ul', {
    staticClass: "space-y-2"
  }, _vm._l((_vm.visible_resource_questions), function(resource, index) {
    return _c('li', {
      key: index,
      staticClass: "flex items-start"
    }, [_c('button', {
      staticClass: "underline text-blue-600 hover:text-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400 rounded",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.openResourceLink(resource)
        }
      }
    }, [_vm._v("\n              " + _vm._s(resource.resourceName) + "\n            ")])])
  }), 0), _vm._v(" "), (!_vm.visible_resource_questions.length) ? _c('p', {
    staticClass: "text-sm text-gray-500"
  }, [_vm._v("\n          No content or multimedia has been created or activated.\n        ")]) : _vm._e()])]), _vm._v(" "), _c('section', {
    staticClass: "rounded-xl border border-gray-200",
    attrs: {
      "aria-labelledby": "guiding-title"
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "px-4 py-3 sm:px-3"
  }, [_c('ol', {
    staticClass: "space-y-3 list-decimal pl-5"
  }, _vm._l((_vm.guiding_questions), function(guiding, index) {
    return (guiding.is_active) ? _c('li', {
      key: index,
      staticClass: "text-gray-900 break-words"
    }, [_vm._v("\n            " + _vm._s(guiding.question) + "\n          ")]) : _vm._e()
  }), 0), _vm._v(" "), (!_vm.visible_guiding_questions.length) ? _c('p', {
    staticClass: "text-sm text-gray-500"
  }, [_vm._v("\n          No guiding questions have been created or activated.\n        ")]) : _vm._e()])]), _vm._v(" "), (_vm.getCurrentDiscussion.enable_grading) ? _c('section', {
    staticClass: "rounded-xl border border-gray-200",
    attrs: {
      "aria-labelledby": "assessment-title"
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "divide-y divide-gray-100 font-manrope"
  }, _vm._l((_vm.criterias), function(criteria, index) {
    return _c('details', {
      key: index,
      staticClass: "group open:bg-gray-50/60"
    }, [_c('summary', {
      staticClass: "flex items-start justify-between gap-3 px-6 py-3 cursor-pointer select-none focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-400"
    }, [_c('span', {
      staticClass: "text-sm text-gray-900 hover:underline font-medium"
    }, [_vm._v("\n              " + _vm._s(criteria.title) + "\n            ")]), _vm._v(" "), _vm._m(4, true)]), _vm._v(" "), _c('div', {
      staticClass: "px-6 py-3"
    }, [(criteria.description) ? _c('div', {
      staticClass: "text-sm text-gray-700 leading-relaxed html-content",
      domProps: {
        "innerHTML": _vm._s(typeof criteria.description === 'object' ? criteria.description.join('. ') : criteria.description)
      }
    }) : _vm._e(), _vm._v(" "), (criteria.points_description && criteria.points_description.length) ? _c('div', {
      staticClass: "mt-3"
    }, [_c('h3', {
      staticClass: "text-xs font-semibold uppercase tracking-wide text-gray-500 mb-2"
    }, [_vm._v("\n                Levels\n              ")]), _vm._v(" "), _c('ul', {
      staticClass: "space-y-2"
    }, _vm._l((criteria.points_description), function(point, pIdx) {
      return (point.description !== '') ? _c('li', {
        key: pIdx,
        staticClass: "text-sm text-gray-800"
      }, [_c('span', {
        staticClass: "font-medium"
      }, [_vm._v(_vm._s(point.value))]), _vm._v(" "), _c('span', {
        staticClass: "text-gray-700"
      }, [_vm._v(" — " + _vm._s(point.description))])]) : _vm._e()
    }), 0)]) : _vm._e()])])
  }), 0)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray-100 rounded-t-xl px-4 py-3 sm:px-5"
  }, [_c('h2', {
    staticClass: "font-semibold font-manrope text-gray-900",
    attrs: {
      "id": "instructions-title"
    }
  }, [_vm._v("\n          Instructions\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray-100 rounded-t-xl px-4 py-3 sm:px-5"
  }, [_c('h2', {
    staticClass: "font-semibold font-manrope text-gray-900",
    attrs: {
      "id": "resources-title"
    }
  }, [_vm._v("\n          Content & Multimedia\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray-100 rounded-t-xl px-3 py-3 sm:px-5"
  }, [_c('h2', {
    staticClass: "font-semibold font-manrope text-gray-900",
    attrs: {
      "id": "guiding-title"
    }
  }, [_vm._v("\n          Guiding Questions\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "bg-gray-100 rounded-t-xl px-4 py-3 sm:px-5"
  }, [_c('h2', {
    staticClass: "font-semibold font-manrope text-gray-900",
    attrs: {
      "id": "assessment-title"
    }
  }, [_vm._v("\n          Assessment Criteria\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "ml-auto inline-flex h-5 w-5 text-xs items-center rounded-full justify-center transition-transform group-open:rotate-180",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-chevron-down"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-0794758d!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/liveDiscussion/tabs/LDPromptTab.vue
// module id = 1750
// module chunks = 61